/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from 'semantic-ui-react';
import HeaderMenu from '../components/header/header_menu';
import { logout } from '../redux/actions/loginAction'
import { connect } from 'react-redux'
class Header extends Component {

    handleChange = (e, data) => {
        // console.log(e)
        let signOut = data.value

        if (signOut === 'sign_out') {
            localStorage.removeItem('apiToken')
            localStorage.removeItem('userId')
            localStorage.removeItem('customerNo')
            window.location.reload()
        }
    }


    render() {
        let headerOptions = [
            {
                key: 'account', text: `Account`, value: 'default'
            },
            {
                key: 'approval', text: `Settings`, as: Link, to: '/settings'
            },
            {
                key: 'sign-out', text: 'Sign Out', value: 'sign_out', onClick: this.props.logout
            }
        ]
        return (
            <React.Fragment>
                <div className="navigationMenu">
                    <nav className="navbar navbar-expand-sm bg-white p-fixed-top w3-border-bottom">
                        <span className="togbutton"> <i data-toggle="modal" data-target="#exampleModal1" className=" fas fa-bars"></i>&nbsp;&nbsp;  </span>
                        <Link className="icon_tracker" to="#"><img src="assets/svg/t_a.svg" width="25px" alt="scct icon" /> <label style={{ color: "#9576AF", fontWeight: 700, letterSpacing: '0.5px' }}> Partner Onboarding </label></Link>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation">
                            <i className="fas fa-ellipsis-v w3-text-black"></i>
                        </button>
                        <div className="collapse navbar-collapse justify-content-end" id="navigation" >
                            <HeaderMenu speed_token={this.props.loginUsers.speedToken} role={this.props.loginUsers.role} customerNo={this.props.loginUsers.customerNo} user_key={this.props.loginUsers.userKey} />
                            <Dropdown pointing="top right" className="nav-link" trigger={(
                                <span className="no-icon w3-small">Welcome, {this.props.loginUsers.userName}</span>
                            )}
                                options={headerOptions}
                                onChange={this.handleChange}
                            />

                        </div>
                    </nav>
                </div>
            </React.Fragment>
        )
    }
}
const mapStateToProps = ({ loginReducer }) => {
    localStorage.setItem("apiToken", loginReducer.loginUsers.token);
    localStorage.setItem("customerNo", loginReducer.loginUsers.customerNo);
    localStorage.setItem("userId", loginReducer.loginUsers.userId);
    if (+loginReducer.loginUsers.customerNo == 1122) {
        localStorage.setItem("timezone", 'America/Sao_Paulo');
    }
    else {
        localStorage.setItem("timezone", 'Asia/Calcutta|Asia/Kolkata');
    }
    return loginReducer
};
const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => dispatch(logout()),
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);